import {
  IconAlertTriangle,
  IconCircleCheckFilled,
  IconCircleX,
  IconClock,
} from '@tabler/icons-react';
import type { ReactNode } from 'react';
import classes from './StatusBadge.module.css';

export type StatusTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

/** Tona göre varsayılan ikon (personel-sertifikalar.jpeg rozetleri; M6f G1-07). */
const TONE_ICON: Partial<Record<StatusTone, ReactNode>> = {
  success: <IconCircleCheckFilled size={13} />,
  warning: <IconAlertTriangle size={13} stroke={2.2} />,
  danger: <IconCircleX size={13} stroke={2.2} />,
  info: <IconClock size={13} stroke={2.2} />,
};

export interface StatusBadgeProps {
  tone: StatusTone;
  /** Kendi ikonu; `withIcon` ile birlikte verilirse bu kazanır. */
  icon?: ReactNode;
  /** Tona göre varsayılan ikon (success ✓, warning ⚠, danger ✕, info saat). */
  withIcon?: boolean;
  /** `pill`: renkli zeminli hap (varsayılan); `dot`: zeminsiz, renkli nokta ve metin ("● On Board"). */
  variant?: 'pill' | 'dot';
  /** Hapın çevresinde ton renginde ince kenar. */
  outlined?: boolean;
  children: ReactNode;
}

/** Durum rozeti: hap biçimi, renkler token'lardan (docs/ekranlar/README.md); isteğe bağlı ikon. */
export function StatusBadge({
  tone,
  icon,
  withIcon = false,
  variant = 'pill',
  outlined = false,
  children,
}: StatusBadgeProps) {
  const glyph = icon ?? (withIcon ? TONE_ICON[tone] : null);
  return (
    <span
      className={classes.badge}
      data-tone={tone}
      data-variant={variant}
      data-outlined={outlined || undefined}
    >
      {variant === 'dot' ? <span className={classes.dot} data-dot aria-hidden /> : null}
      {glyph ? (
        <span className={classes.icon} aria-hidden>
          {glyph}
        </span>
      ) : null}
      {children}
    </span>
  );
}
